import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

export const ObservationNode = inlineAtomNode('observation', 'a', {
  reference: { dataAttr: 'data-reference' },
  display: { isDisplay: true, default: '' },
  codingDisplay: { dataAttr: 'data-coding-display', default: '' },
  system: { dataAttr: 'data-system', default: '' },
  code: { dataAttr: 'data-code', default: '' },
  scaleType: { dataAttr: 'data-scale-type' },
  unit: { dataAttr: 'data-unit' },
  /* The coded answer list an ordinal observation is scored against (the
   * Pain-severity LOINC answers, for one). An observation with no answer list
   * still renders `data-answer-options="[]"`, because `[]` is truthy — see the
   * round-trip test asserting exactly that. */
  answerOptions: { dataAttr: 'data-answer-options', default: [], json: true },
})
